import { HTMLAttributes } from 'react';
import styles from './Box.module.css';

interface BoxProps extends HTMLAttributes<HTMLDivElement> {}

const Box = ({ children, ...props }: BoxProps): JSX.Element => {
  return (
    <div className={styles.box} {...props}>
      {children}
    </div>
  );
};

export default Box;
